module.exports = __webpack_public_path__ + "static/img/quxiaoquantijingyin.35f230d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/quxiaoquantijingyin.png
// module id = NaFP
// module chunks = 24